import { baseOf } from './cash';

export const formatCurrency = (amount, currency = 'USD') => {
    let formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .format(Number(amount))
    .replace('$', ''); // Removing the dollar sign if you don't need it

    if(formatted > 0 && formatted-1 < 0){
      formatted = Number(formatted).toFixed(3)
    }

    return formatted
  };

  // Precision is keyed by the base coin, so a pair in either cash currency
  // (and a bare base symbol) formats the same way.
  const BASES_WITH_EIGHT_DECIMALS = ['SHIB', 'FLOKI', 'BONK', 'PEPE', 'BOME', '1000SATS'];
  const BASES_WITH_FIVE_DECIMALS = ['DOGE', 'PEOPLE', 'VET', 'MEME'];
  const BASES_WITH_FOUR_DECIMALS = [
    'ADA', 'ALGO', 'ARB', 'GRT', 'HBAR', 'ICP', 'IMX',
    'LDO', 'POL', 'SEI', 'SUI', 'TRX', 'XLM', 'XRP'
  ];
  const BASES_WITH_THREE_DECIMALS = [
    'WIF', 'ATOM', 'DOT', 'FIL', 'OP', 'RUNE', 'STX', 'NEAR', 'UNI', 'RENDER'
  ];

  export const formatPrice = (pairName, price) => {
    const base = baseOf(pairName)?.toUpperCase();

    if (BASES_WITH_EIGHT_DECIMALS.includes(base)) {
      return price.toFixed(8);
    }

    if (BASES_WITH_FIVE_DECIMALS.includes(base)) {
      return price.toFixed(5);
    }

    if (BASES_WITH_FOUR_DECIMALS.includes(base)) {
      return price.toFixed(4);
    }

    if (BASES_WITH_THREE_DECIMALS.includes(base)) {
      return price.toFixed(3);
    }

    return price.toFixed(2);
  };



export const getCookieDomainFromUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    return hostname.startsWith('www.') ? `.${hostname.slice(4)}` : `.${hostname}`;
  } catch (error) {
    console.error('Invalid URL:', url);
    return '';
  }
};
